import { createSelector } from 'reselect';

export const favoriteSelector = state => state.serviceFavoriteStatus;

export const inFavoriteSelector = createSelector(
  favoriteSelector,
  subState => subState.inFavorite
);

export const showTooltipSelector = createSelector(
  favoriteSelector,
  subState => subState.showTooltip
);
